(function(){
var BLOCK = "'Graduate','Arial Black',Impact,sans-serif";
var SCRIPT = "'Yellowtail','Brush Script MT',cursive";
var baseball = {
  body: function(f){ return 'M166 56 ' + (f ? 'L200 94 L234 56' : 'Q200 70 234 56') + ' L272 62 L324 100 L308 156 L280 142 L282 360 Q200 376 118 360 L120 142 L92 156 L76 100 L128 62 Z'; },
  trim: function(f){ return 'M166 56 ' + (f ? 'L200 94 L234 56' : 'Q200 70 234 56') + ' M76 100 L92 156 M324 100 L308 156'; },
  tw: 7,
  extras: function(f, c){
    if (!f) return '';
    var s = '<path d="M200 94 L200 368" stroke="' + c + '" stroke-width="3"/>';
    [118,156,194,232,270,308].forEach(function(y){ s += '<circle cx="207" cy="' + y + '" r="3" fill="' + c + '"/>'; });
    return s;
  },
  text: function(f){ return f
    ? { top:{ y:156, size:38, max:170, font:SCRIPT }, num:{ x:150, y:262, size:56 } }
    : { top:{ y:116, size:20, max:130, font:BLOCK }, num:{ x:200, y:252, size:104 } }; }
};
var none = function(){ return ''; };
var SH = {
  basketball: {
    body: function(f){ return 'M140 58 L168 58 Q200 ' + (f ? 112 : 80) + ' 232 58 L260 58 Q266 120 292 150 L294 368 L106 368 L108 150 Q134 120 140 58 Z'; },
    trim: function(f){ return 'M168 58 Q200 ' + (f ? 112 : 80) + ' 232 58 M140 58 Q134 120 108 150 M260 58 Q266 120 292 150'; },
    tw: 8, extras: none,
    text: function(f){ return f
      ? { top:{ y:142, size:24, max:150, font:BLOCK }, num:{ x:200, y:262, size:104 } }
      : { top:{ y:120, size:24, max:132, font:BLOCK }, num:{ x:200, y:258, size:108 } }; }
  },
  football: {
    body: function(f){ return 'M162 58 ' + (f ? 'L200 96 L238 58' : 'Q200 74 238 58') + ' L292 66 L330 100 L322 170 L290 166 L286 368 L114 368 L110 166 L78 170 L70 100 L108 66 Z'; },
    trim: function(f){ return 'M162 58 ' + (f ? 'L200 96 L238 58' : 'Q200 74 238 58') + ' M70 100 L78 170 M330 100 L322 170 M88 84 L94 168 M312 84 L306 168'; },
    tw: 7, extras: none,
    text: function(f){ return f
      ? { top:{ y:128, size:20, max:130, font:BLOCK }, num:{ x:200, y:276, size:126 } }
      : { top:{ y:118, size:22, max:150, font:BLOCK }, num:{ x:200, y:276, size:128 } }; }
  },
  soccer: {
    body: function(f){ return 'M168 56 ' + (f ? 'L200 92 L232 56' : 'Q200 72 232 56') + ' L270 62 L322 104 L304 150 L276 136 L278 368 L122 368 L124 136 L96 150 L78 104 L130 62 Z'; },
    trim: function(f){ return 'M168 56 ' + (f ? 'L200 92 L232 56' : 'Q200 72 232 56') + ' M78 104 L96 150 M322 104 L304 150'; },
    tw: 7, extras: none,
    text: function(f){ return f
      ? { top:{ y:140, size:22, max:140, font:BLOCK }, num:{ x:200, y:254, size:96 } }
      : { top:{ y:118, size:20, max:136, font:BLOCK }, num:{ x:200, y:252, size:100 } }; }
  },
  baseball: baseball,
  softball: baseball
};

function hexOk(v){ return /^#[0-9a-f]{6}$/i.test(v); }
function norm(v){
  v = (v||'').trim(); if (v[0] !== '#') v = '#' + v;
  if (/^#[0-9a-f]{3}$/i.test(v)) v = '#' + v[1]+v[1]+v[2]+v[2]+v[3]+v[3];
  return v.toLowerCase();
}
function rgb(h){ return [1,3,5].map(function(i){ return parseInt(h.substr(i,2),16); }); }
function lum(h){ var c = rgb(h); return (0.2126*c[0] + 0.7152*c[1] + 0.0722*c[2]) / 255; }
function toHex(c){ return '#' + c.map(function(v){ return ('0'+v.toString(16)).slice(-2); }).join(''); }
function fit(el, txt, max){
  el.textContent = txt; el.removeAttribute('textLength'); el.removeAttribute('lengthAdjust');
  try { if (el.getComputedTextLength() > max){ el.setAttribute('textLength', max); el.setAttribute('lengthAdjust','spacingAndGlyphs'); } } catch(e){}
}
function palette(img){
  var c = document.createElement('canvas'), n = 56; c.width = c.height = n;
  var x = c.getContext('2d', { willReadFrequently: true });
  x.drawImage(img, 0, 0, n, n);
  var d, buckets = {};
  try { d = x.getImageData(0, 0, n, n).data; } catch(e){ return []; }
  for (var i = 0; i < d.length; i += 4){
    if (d[i+3] < 160) continue;
    var r = d[i], g = d[i+1], b = d[i+2];
    if (r > 236 && g > 236 && b > 236) continue;
    var k = (r>>5) + ',' + (g>>5) + ',' + (b>>5);
    var o = buckets[k] || (buckets[k] = { n:0, r:0, g:0, b:0 });
    o.n++; o.r += r; o.g += g; o.b += b;
  }
  var list = Object.keys(buckets).map(function(k){ var o = buckets[k]; return { n:o.n, c:[Math.round(o.r/o.n), Math.round(o.g/o.n), Math.round(o.b/o.n)] }; })
    .sort(function(a,z){ return z.n - a.n; });
  var out = [];
  list.forEach(function(it){
    if (out.length >= 5) return;
    if (out.every(function(o){ return Math.hypot(o[0]-it.c[0], o[1]-it.c[1], o[2]-it.c[2]) > 70; })) out.push(it.c);
  });
  return out.map(toHex);
}

function init(root){
  if (root.dataset.cdrReady || !root.querySelector('[data-submit]')) return;
  root.dataset.cdrReady = '1';
  var q = function(s){ return root.querySelector(s); };
  var qa = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var UC_KEY = root.getAttribute('data-uc-key') || '';
  var form = root.querySelector('form');
  var state = { jersey:'#141414', secondary:'#f5c400', background:'#cfcfcf', border:'#141414', active:'jersey', touched:false, logo:'' };
  function val(k){ var el = q('[data-in="'+k+'"]'); return el ? el.value.trim() : ''; }
  function checked(attr){ var el = q('input[' + attr + ']:checked'); return el ? el.getAttribute(attr) : ''; }

  function setColor(slot, hex, fromUser){
    if (!hexOk(hex)) return;
    state[slot] = hex;
    if (fromUser) state.touched = true;
    q('[data-color="'+slot+'"]').value = hex;
    var t = q('[data-hex="'+slot+'"]'); t.value = hex.toUpperCase(); t.classList.remove('is-bad');
    render();
  }
  function setActive(slot){
    state.active = slot;
    qa('.cdr__color').forEach(function(el){ el.classList.toggle('is-active', el.dataset.slot === slot); });
  }

  function render(){
    var sport = checked('data-sport') || 'basketball', front = checked('data-side') === 'front';
    var S = SH[sport], d = S.body(front), L = S.text(front);
    q('[data-front-only]').hidden = !front;
    q('[data-j="border"]').setAttribute('fill', state.border);
    var bg = q('[data-j="bg"]'); bg.setAttribute('fill', state.background); bg.setAttribute('stroke', state.secondary);
    ['shadow','body','shade'].forEach(function(k){ q('[data-j="'+k+'"]').setAttribute('d', d); });
    q('[data-j="body"]').setAttribute('fill', state.jersey);
    var trim = q('[data-j="trim"]'); trim.setAttribute('d', S.trim(front)); trim.setAttribute('stroke', state.secondary); trim.setAttribute('stroke-width', S.tw);
    q('[data-j="extras"]').innerHTML = S.extras(front, state.secondary);

    var top = q('[data-j="top"]'), num = q('[data-j="num"]');
    var topTxt = front ? (val('front') || 'Team') : (val('last') || 'Name');
    top.setAttribute('y', L.top.y); top.setAttribute('font-size', L.top.size); top.setAttribute('font-family', L.top.font);
    top.setAttribute('fill', state.secondary);
    top.setAttribute('letter-spacing', L.top.font === SCRIPT ? 0 : 2);
    fit(top, L.top.font === SCRIPT ? topTxt : topTxt.toUpperCase(), L.top.max);
    var n = val('number').replace(/\D/g,'') || '00';
    num.setAttribute('x', L.num.x); num.setAttribute('y', L.num.y);
    num.setAttribute('font-size', n.length > 2 ? Math.round(L.num.size * 0.78) : L.num.size);
    num.setAttribute('fill', state.secondary);
    num.textContent = n;

    var onbg = lum(state.background) > 0.5 ? '#4a4a4a' : '#dcdcdc';
    qa('[data-onbg="fill"]').forEach(function(el){ el.setAttribute('fill', onbg); });
    qa('[data-onbg="stroke"]').forEach(function(el){ el.setAttribute('stroke', onbg); });
    var school = val('school');
    var initials = school.split(/\s+/).filter(function(w){ return /^[A-Za-z]/.test(w) && !/^(of|the|and|high|school|hs)$/i.test(w); }).slice(0,3).map(function(w){ return w[0].toUpperCase(); }).join('');
    q('[data-j="initials"]').textContent = state.logo ? '' : (initials || 'LOGO');
    q('[data-j="logo"] circle').style.display = state.logo ? 'none' : '';

    var pb = q('[data-j="platebox"]'); pb.setAttribute('fill', state.jersey); pb.setAttribute('stroke', state.secondary);
    var pt = lum(state.jersey) > 0.55 ? '#141414' : '#ffffff';
    ['p1','p2','p3'].forEach(function(k){ q('[data-j="'+k+'"]').setAttribute('fill', pt); });
    var full = ((val('first') || 'First') + ' ' + (val('last') || 'Last')).toUpperCase();
    fit(q('[data-j="p1"]'), full + ' - ' + (val('number') || '##'), 138);
    fit(q('[data-j="p2"]'), (school || 'School name').toUpperCase(), 138);
    fit(q('[data-j="p3"]'), 'CLASS OF ' + (val('year') || 'YEAR'), 138);
  }

  qa('[data-sport-card]').forEach(function(card){
    var k = card.getAttribute('data-sport-card');
    card.querySelector('i').innerHTML = '<svg viewBox="62 48 276 330" aria-hidden="true"><path fill="currentColor" d="' + SH[k].body(false) + '"/></svg>';
  });
  qa('[data-color]').forEach(function(el){
    el.addEventListener('input', function(){ setColor(el.dataset.color, el.value.toLowerCase(), true); });
  });
  qa('[data-hex]').forEach(function(el){
    el.addEventListener('input', function(){
      var v = norm(el.value), k = el.dataset.hex;
      if (hexOk(v)) { state[k] = v; state.touched = true; q('[data-color="'+k+'"]').value = v; el.classList.remove('is-bad'); render(); }
      else el.classList.add('is-bad');
    });
    el.addEventListener('blur', function(){ var v = norm(el.value); if (hexOk(v)) el.value = v.toUpperCase(); else { el.value = state[el.dataset.hex].toUpperCase(); el.classList.remove('is-bad'); } });
  });
  qa('.cdr__color').forEach(function(el){
    el.addEventListener('click', function(){ setActive(el.dataset.slot); });
    el.addEventListener('focusin', function(){ setActive(el.dataset.slot); });
  });

  function showSwatches(cols){
    var all = cols.concat(['#ffffff', '#141414', '#cfcfcf']).filter(function(v,i,a){ return a.indexOf(v) === i; });
    var box = q('[data-swatches]'); box.innerHTML = '';
    all.forEach(function(h){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cdr__sw'; b.style.background = h; b.title = h.toUpperCase();
      b.setAttribute('aria-label', 'Use ' + h.toUpperCase());
      b.addEventListener('click', function(){ setColor(state.active, h, true); });
      box.appendChild(b);
    });
    q('[data-palette]').hidden = false;
  }

  var logoInput = q('[data-logo]');
  logoInput.addEventListener('change', function(){
    var f = logoInput.files[0]; if (!f) return;
    if (f.size > 10 * 1024 * 1024){ alert('That file is over 10 MB. Please choose a smaller logo.'); logoInput.value = ''; return; }
    var url = URL.createObjectURL(f), img = new Image();
    img.onload = function(){
      state.logo = url;
      q('[data-j="logoimg"]').setAttribute('href', url);
      var cols = palette(img);
      if (cols.length) {
        showSwatches(cols);
        if (!state.touched){
          setColor('jersey', cols[0]);
          setColor('secondary', cols[1] || (lum(cols[0]) > 0.55 ? '#141414' : '#ffffff'));
          setColor('border', cols[0]);
        }
      }
      render();
    };
    img.src = url;
  });

  qa('[data-in]').forEach(function(el){ el.addEventListener('input', render); });
  qa('input[data-sport], input[data-side]').forEach(function(el){ el.addEventListener('change', render); });
  var date = q('[data-date]'); if (date) date.min = new Date().toISOString().slice(0,10);

  var btn = q('[data-submit]'), out = q('[data-logo-out]');
  form.addEventListener('submit', function(e){
    if (form.dataset.ready) return;
    var f = logoInput.files[0];
    if (!f) return;
    e.preventDefault();
    var done = function(note){
      out.value = note; form.dataset.ready = '1';
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    };
    if (!UC_KEY) return done(f.name + ' (selected but not attached; request the file from the coach)');
    btn.disabled = true; btn.textContent = 'Uploading logo…';
    var fd = new FormData();
    fd.append('UPLOADCARE_PUB_KEY', UC_KEY);
    fd.append('UPLOADCARE_STORE', '1');
    fd.append('file', f);
    fetch('https://upload.uploadcare.com/base/', { method:'POST', body:fd })
      .then(function(r){ return r.json(); })
      .then(function(j){
        btn.disabled = false;
        done(j && j.file ? 'Uploadcare file ' + j.file + ' (' + f.name + ') https://ucarecdn.com/' + j.file + '/' : f.name + ' (upload failed; request the file from the coach)');
      })
      .catch(function(){ btn.disabled = false; done(f.name + ' (upload failed; request the file from the coach)'); });
  });

  render();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
}

function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-cdr]'), init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
})();